import request from '@/utils/request'
// 创建会话
export function shopExtendInfos(data) {
    return request({
        url: `/shop/shop/shopExtendInfos`,
        method: "GET",
        params: data
    });
}

// 创建会话
export function dictExpresses(data) {
    return request({
        url: `/shop/shop/dictExpresses`,
        method: "GET",
        params: data
    });
}

// 获取省份的接口
export function getProvince(data) {
    return request({
        url: `/shop/region/province`,
        method: "GET",
        params: data
    });
}

//获取市的接口
export function getCity(data) {
    return request({
        url: `/shop/region/city/${data.id}`,
        method: "GET",
        params: data
    });
}



//新增公告
export function postShopExtendInfos(data) {
    return request({
        url: `/shop/shop/shopExtendInfos`,
        method: "POST",
        data
    });
}
// 修改公告
export function putShopExtendInfos(data) {
    return request({
        url: `/shop/shop/shopExtendInfos/${data.id}`,
        method: "PUT",
        data
    });
}


//获取运费设置列表


export function getShopExpressFees(data) {
    return request({
        url: `/shop/shop/shopExpressFees`,
        method: "GET",
        params: data
    });
}

// 新增运费
export function postShopExpressFees(data) {
    return request({
        url: `/shop/shop/shopExpressFees`,
        method: "POST",
        data
    });
}
//获取运费设置详情
export function getShopExpressFee(data) {
    return request({
        url: `/shop/shop/shopExpressFees/${data.id}`,
        method: "GET",
        params: data
    });
}

//删除运费设置详情
export function deleteShopExpressFee(data) {
    return request({
        url: `/shop/shop/shopExpressFees/${data.id}`,
        method: "DELETE",
        data
    });
}
//修改运费设置详情
export function putShopExpressFee(data) {
    return request({
        url: `/shop/shop/shopExpressFees/${data.id}`,
        method: "PUT",
        data
    });
}




//获取整个地区树

export function getAreaTree(data) {
    return request({
        url: `/shop/region/areaTree/${data.level}`,
        method: "GET",
        params: data
    });
}

//获取地区

export function getArea(data) {
    return request({
        url: `/shop/region/area/${data.id}`,
        method: "GET",
        params: data
    });
}

//售后地址新增
export function shopCustomerServiceAddresses(data) {
    return request({
        url: `/shop/shop/shopCustomerServiceAddresses`,
        method: "POST",
        data
    });
}

//售后地址修改
export function putCustomerServiceAddresses(data) {
    return request({
        url: `/shop/shop/shopCustomerServiceAddresses/${data.id}`,
        method: "PUT",
        data
    });
}

//售后地址删除
export function deleteCustomerServiceAddresses(data) {
    return request({
        url: `/shop/shop/shopCustomerServiceAddresses/${data.id}`,
        method: "DELETE",
        data
    });
}
//获取售后地址的列表
export function getShopCustomerServiceAddresses(data) {
    return request({
        url: `/shop/shop/shopCustomerServiceAddresses`,
        method: "GET",
        params: data
    });
}

//售后地址新增
export function getShopCustomerServiceAddresse(data) {
    return request({
        url: `/shop/shop/shopCustomerServiceAddresses/${data.id}`,
        method: "GET",
        params: data
    });
}

//---------------------------商户管理，检查资质

export function getCertifyForCheck(data) {
    return request({
        url: `/shop/compShopCertify/getCertifyForCheck`,
        method: "GET",
        params: data
    });
}

// 保存细项检查结果（临时表）
// type: certify 资质
// type: product 商品
// type: order 订单 
export function saveTemporaryCheck(data, type) {
    return request({
        url: `/shop/shopcheckrecord/saveTemporaryCheck/${type}`,
        method: "POST",
        data: data
    });
}

//保存检查记录
export function saveCheckRecordDetails(data, type) {
    return request({
        url: `/shop/shopcheckrecord/saveCheckRecordDetails`,
        method: "POST",
        data: data
    });
}

// /shopcheckrecord/queryCheckRecordDetail
// 查询检查记录 列表 (资质无分页) 
// 检查类型 1-资质 2-商品 3-订单 4-售后订单
export function queryCheckRecordDetail(data) {
    return request({
        url: `/shop/shopcheckrecord/queryCheckRecordDetail`,
        method: "POST",
        data: data
    });
}

//平台业务管理-商户检查   查询订单详情快照
export function queryOrderDetail(data) {
    return request({
        url: `/shop/shopcheckrecord/queryOrderDetail/${data.recordId}`,
        method: 'get',
        params: data
    })
}

//   查询店铺信息审核列表
export function queryShopListAudit(data) {
    return request({
        url: `/shop/shop/basic/information/sys/list`,
        method: 'get',
        params: data
    })
}

// 店铺信息审核
export function auditShopInformation(data) {
    return request({
        url: `/shop/shop/basic/information/sys/audit`,
        method: "PUT",
        data: data,
    });
}
//查询店铺信息基本信息
export function getShopInformation(data) {
    console.log(data,'--data')
    return request({
        url: `/shop/shop/basic/information/infoById/${data.id}`,
        method: "GET" 
    });
}

// 挂靠部门信息审核
export function examinePage(data) {
  return request({
      url: `/shop/setting/deptSettingsExpansionInformation/examinePage`,
      method: "post",
      data:data,
  })
}

// 挂靠部门信息审核
export function infoDetail(id) {
  return request({
      url: `/shop/setting/deptSettingsExpansionInformation/info/${id}`,
      method: "get"
  })
}

// 部门售后信息审核
export function checkSection(data) {
  return request({
      url: `/shop/setting/deptSettingsExpansionInformation/check`,
      method: "put",
      data
  })
}

// /shop/lineFee 修改
export function shopLineFeePut(data) {
    return request({
        url: `/shop/shop/lineFee`,
        method: "put",
        data
    })
} 

// 查询当前商户是否线上收取费用 
export function shopLineFeeGet(data) {
    return request({
        url: `/shop/shop/lineFee`,
        method: "GET",
        params: data 
    })
} 
// 修改学术康贝是否收业务款
// /dfc/study/business 
export function putDfStudyBusiness(data){
    return request({
        url: `/shop/dfc/study/business`,
        method: "PUT",
        data
    })
}

export function getDfStudyBusiness(data){
    return request({
        url: `/shop/dfc/study/business`,
        method: "GET",
        params: data 
    })
}
// 修改康贝商户费率
export function updateMerchantNoRate(data){
    return request({
        url: `/shop/shop/updateMerchantNoRate`,
        method: "PUT",
        data
    })
}
// 查询商户详情
export function getShopDetail(shopId){
    return request({
        url: `/shop/shop/shopById`,
        method: "GET",
        params: { id: shopId }
    })
}